<script>
    import ContentSection from "../../../common/ContentSection.svelte";
    import {_} from "svelte-i18n";
    import {createEventDispatcher} from "svelte";

    let dispatch = createEventDispatcher();

    export let video;
</script>

<ContentSection on:click={() => dispatch("click")} bigImage>
    <div slot="title">
        <img class="highlight-image" src={video.image} alt={video.title}/>
    </div>
    <div slot="content" style="margin-bottom: -8px;">
        <div class="headline-s title">{video.title}</div>
        <div class="subtitle">
            <div class="headline-xs flex">{$_("video_title")}</div>
            <div class="text-l subtitle-appendix flex">
                <img
                        src="./images/icons/clock.svg"
                        alt={$_("time_alt")}
                        class="clock-icon"
                />
                {video.duration}
                {$_("minutes")}
            </div>

            <div class="flex disable-mobile"/>
        </div>
    </div>
</ContentSection>

<style>
    .subtitle {
        margin: 8px 0;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

    .disable-mobile {
        display: none;
    }

    .subtitle-appendix {
        display: flex;
        flex-direction: row;
        justify-content: end;
        align-items: center;
    }

    .highlight-image {
        width: 100%;
        aspect-ratio: 3/2;
        height: 100%;
        object-fit: cover;
    }

    @media (min-width: 1440px) {
        .flex {
            flex: 1;
        }

        .subtitle {
            justify-content: space-evenly;
        }

        .title {
            padding-right: 296px;
        }

        .disable-mobile {
            display: block;
        }

        .highlight-image {
            aspect-ratio: 3/2;
            width: 340px
        }
    }

    .clock-icon {
        margin-bottom: 4px;
        margin-right: 4px;
    }
</style>
